import { Capacitor } from '@capacitor/core';

/**
 * Initialize Capgo OTA silent auto-update via Capgo Cloud.
 * With autoUpdate: true in capacitor.config.ts, the plugin handles
 * downloading and applying bundles automatically in the background.
 * We only need to call notifyAppReady() to confirm the JS loaded successfully.
 */
export async function initCapacitorUpdater(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { CapacitorUpdater } = await import('@capgo/capacitor-updater');
    await CapacitorUpdater.notifyAppReady();
    console.log('[Capgo] notifyAppReady — autoUpdate handles the rest');
  } catch (e) {
    console.warn('[Capgo] OTA init failed (non-fatal):', e);
  }
}
